import { gql, useQuery } from "@apollo/client";

export interface BlogPostForEdit {
  id: string;
  tenantId: string;
  title: string;
  slug: string;
  author: string;
  summary: string | null;
  body: string | null;
  publishAt: string | null;
  featuredImageUrl: string | null;
  featuredImageAlt: string | null;
  status: "draft" | "scheduled" | "published";
  tagNames: string[];
  createdAt: string;
  updatedAt: string;
}

const BLOG_POST_FOR_EDIT = gql`
  query BlogPostForEdit($id: String!) {
    BlogPost(id: $id) {
      id
      tenantId
      title
      slug
      author
      summary
      body
      publishAt
      featuredImageUrl
      featuredImageAlt
      status
      tagNames
      createdAt
      updatedAt
    }
  }
`;

export function useBlogPostData(id: string | undefined) {
  const result = useQuery<{ BlogPost: BlogPostForEdit | null }>(
    BLOG_POST_FOR_EDIT,
    {
      variables: { id: id ?? "" },
      skip: !id,
      fetchPolicy: "cache-and-network",
    },
  );
  return {
    post: result.data?.BlogPost ?? null,
    loading: result.loading,
    error: result.error,
    refetch: result.refetch,
  };
}

export const BLOG_POST_FOR_EDIT_QUERY = BLOG_POST_FOR_EDIT;
